// extracted by mini-css-extract-plugin
module.exports = {"wrap":"index_wrap__1Db31"};